// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__15N0r","content":"ManualTimeModal_content__3qBtJ"};